module.exports = __webpack_public_path__ + "img/23.2923fa57.jpg";